export default "__VITE_ASSET__q03CcScL__"